import React from "react";

import { Button, ButtonProps, withStyles } from "@material-ui/core";

const StyledButton = withStyles(theme => ({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 18,
    fontWeight: 700,
    letterSpacing: "0.3px",
    padding: "10px 24px",
    borderRadius: "5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    "&.bsm": {
      fontWeight: 400,
      color: "#3933B7",
      fontFamily: "Poppins !important",
      "&:disabled": {
        color: "#727375",
      },
    },
    "&.aa": {
      color: "#07828D",
      "&:disabled": {
        color: "#727375",
        opacity: 0.5,
      },
    },
  },
}))(Button);

export const ViewButton = (props: ButtonProps & { brand: string }) => (
  <StyledButton {...props} className={props.brand === "BSM" ? "bsm" : "aa"} />
);
